// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ساختار کلی */
.wrapper-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
  font-family: Estedad-Regular, sans-serif;
  direction: rtl;
  
}

/* هر فیلد انتخاب */
.form-group {
  position: relative;
  width: 100%;
}

/* دکمه انتخاب اصلی */
.dropdown-select {
  padding: 12px 16px;
  border: 2px solid #a1a1a1;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: border 0.25s ease, box-shadow 0.25s ease;
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

.dropdown-select:hover {
  border-color: #EA6C22;
}

.dropdown-select:active {
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.08);
}

/* منو بازشو */
.dropdown-menu {
  position: absolute;
  top: 110%;
  right: 0;
  width: 100%;
  max-height: 260px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 12px;
  box-shadow: 0 8px 18px rgba(17,24,39,0.15);
  overflow: hidden;
  z-index: 999;
  display: flex;
  flex-direction: column;
  animation: scaleUp 0.25s ease forwards;
}

/* انیمیشن باز شدن */
@keyframes scaleUp {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* جستجو داخل منو */
.dropdown-menu-search {
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid #eee;
  outline: none;
  font-size: 14px;
  background: #fafafa;
}

.dropdown-menu-search:focus {
  background: #fff;
  border-bottom: 1px solid #EA6C22;
}

/* لیست آیتم‌ها */
.dropdown-menu-inner {
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-menu-inner::-webkit-scrollbar {
  width: 6px;
}

.dropdown-menu-inner::-webkit-scrollbar-thumb {
  background: rgba(100, 100, 100, 0.3);
  border-radius: 8px;
}

.dropdown-menu-item {
  padding: 10px 14px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.dropdown-menu-item:hover {
  background: rgba(234, 108, 34, 0.1);
  color: #EA6C22;
}

.dropdown-menu-item.is-select {
  background: rgba(234, 108, 34, 0.9);
  color: #fff;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/Table/DropDown/Dropdown.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,cAAc;;AAEhB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,gBAAgB;AAClB","sourcesContent":["/* ساختار کلی */\n.wrapper-column {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: 100%;\n  font-family: Estedad-Regular, sans-serif;\n  direction: rtl;\n  \n}\n\n/* هر فیلد انتخاب */\n.form-group {\n  position: relative;\n  width: 100%;\n}\n\n/* دکمه انتخاب اصلی */\n.dropdown-select {\n  padding: 12px 16px;\n  border: 2px solid #a1a1a1;\n  border-radius: 12px;\n  background: #fff;\n  cursor: pointer;\n  transition: border 0.25s ease, box-shadow 0.25s ease;\n  box-shadow: 0 2px 5px rgba(0,0,0,0.05);\n}\n\n.dropdown-select:hover {\n  border-color: #EA6C22;\n}\n\n.dropdown-select:active {\n  box-shadow: inset 0 2px 4px rgba(0,0,0,0.08);\n}\n\n/* منو بازشو */\n.dropdown-menu {\n  position: absolute;\n  top: 110%;\n  right: 0;\n  width: 100%;\n  max-height: 260px;\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  box-shadow: 0 8px 18px rgba(17,24,39,0.15);\n  overflow: hidden;\n  z-index: 999;\n  display: flex;\n  flex-direction: column;\n  animation: scaleUp 0.25s ease forwards;\n}\n\n/* انیمیشن باز شدن */\n@keyframes scaleUp {\n  from {\n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* جستجو داخل منو */\n.dropdown-menu-search {\n  padding: 10px 12px;\n  border: none;\n  border-bottom: 1px solid #eee;\n  outline: none;\n  font-size: 14px;\n  background: #fafafa;\n}\n\n.dropdown-menu-search:focus {\n  background: #fff;\n  border-bottom: 1px solid #EA6C22;\n}\n\n/* لیست آیتم‌ها */\n.dropdown-menu-inner {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.dropdown-menu-inner::-webkit-scrollbar {\n  width: 6px;\n}\n\n.dropdown-menu-inner::-webkit-scrollbar-thumb {\n  background: rgba(100, 100, 100, 0.3);\n  border-radius: 8px;\n}\n\n.dropdown-menu-item {\n  padding: 10px 14px;\n  cursor: pointer;\n  transition: background 0.2s, color 0.2s;\n}\n\n.dropdown-menu-item:hover {\n  background: rgba(234, 108, 34, 0.1);\n  color: #EA6C22;\n}\n\n.dropdown-menu-item.is-select {\n  background: rgba(234, 108, 34, 0.9);\n  color: #fff;\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
